var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "history-view-container" } }, [
    _c(
      "div",
      {
        staticClass: "mb-4",
        class: {
          "history-container-inner-padding": !_vm.$store.state.clinicHistory
            .sidebarHidden
        },
        attrs: { id: "history-container" }
      },
      [
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.appointmentHistory.id,
              title: _vm.$t("appointmentsHistory"),
              sideBarTrigger: _vm.sideBarTrigger.appointmentHistory
            }
          },
          [_c("appointment-history")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.diseases.id,
              overflowVisible: "",
              title: _vm.$t("diseases"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.diseases
            }
          },
          [_c("history-diseases-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.chronicDiseases.id,
                  overflowVisible: "",
                  title: _vm.$t("chrondiseases"),
                  hideTitleOnOpen: "",
                  sideBarTrigger: _vm.sideBarTrigger.chronicDiseases
                }
              },
              [_c("history-chrondiseases-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.medication.id,
              overflowVisible: "",
              title: _vm.$t("currentMedication"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.medication
            }
          },
          [_c("history-medicines-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.pastMedication.id,
              overflowVisible: "",
              title: _vm.$t("pastMedication"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.pastMedication
            }
          },
          [_c("history-medicines-section", { attrs: { past: "" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.medicationAllergies.id,
              overflowVisible: "",
              title: _vm.$t("allergies"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.medicationAllergies
            }
          },
          [_c("history-med-allergies-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.allergies.id,
              overflowVisible: "",
              title: _vm.$t("otherAllergies"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.allergies
            }
          },
          [_c("history-allergies-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.observations.id,
              title: _vm.$t("observations"),
              sideBarTrigger: _vm.sideBarTrigger.observations
            }
          },
          [_c("history-observations-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.significantEvents.id,
                  title: _vm.$t("relvantsExperiences"),
                  sideBarTrigger: _vm.sideBarTrigger.significantEvents
                }
              },
              [_c("history-events-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.vaccines.id,
              overflowVisible: "",
              title: _vm.$t("vaccines"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.vaccines
            }
          },
          [_c("history-vaccines-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.familyBackground.id,
                  overflowVisible: "",
                  title: _vm.$t("familyhistory"),
                  hideTitleOnOpen: "",
                  sideBarTrigger: _vm.sideBarTrigger.familyBackground
                }
              },
              [_c("history-familybackgrounds-section")],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bef806d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bef806d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/ClinicHistoryView.vue
// module id = 4054
// module chunks = 47